// extracted by mini-css-extract-plugin
export default {"museum":"Museums_museum__8e-sF","museums":"Museums_museums__YG8Vc"};